module.exports = "/_next/static/images/Hero@2x-a9babee90adc3a31a3c2f3464997abd9.png";